
document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll(".skincare-banner .stat strong");

  const animateCounter = (el) => {
    const target = +el.dataset.target;
    let count = 0;
    const speed = 50;

    const update = () => {
      const increment = Math.ceil(target / speed);
      if (count < target) {
        count += increment;
        el.textContent = count.toLocaleString() + (el.dataset.suffix || '');
        requestAnimationFrame(update);
      } else {
        el.textContent = target.toLocaleString() + (el.dataset.suffix || '');
      }
    };

    update();
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        el.textContent = '0' + (el.dataset.suffix || '');
        animateCounter(el);
      }
    });
  }, {
    threshold: 0.6
  });

  counters.forEach(counter => {
    // Prepare: move original text into data-target and data-suffix
    const rawText = counter.textContent;
    const number = parseInt(rawText.replace(/[^\d]/g, ''));
    const suffix = rawText.replace(/\d+/g, '');
    counter.dataset.target = number;
    counter.dataset.suffix = suffix;
    observer.observe(counter);
  });
});

// Active Offers
function copyCode(id) {
  const code = document.getElementById(id).innerText;
  navigator.clipboard.writeText(code).then(() => {
    alert(`Copied: ${code}`);
  });
}






document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll(".mobile-nav__link--button.collapsible-trigger");

  triggers.forEach(trigger => {
    trigger.addEventListener("click", function (e) {
      setTimeout(() => {
        // Agar ye open hai
        if (this.classList.contains("is-open")) {

          // Baaki sab close karo
          triggers.forEach(other => {
            if (other !== this && other.classList.contains("is-open")) {
              other.classList.remove("is-open");

              // Theme ke default behaviour ko trigger karne ke liye
              const id = other.getAttribute("aria-controls");
              const content = document.getElementById(id);
              if (content) content.style.height = "0px";
            }
          });
        }
      }, 150); // theme ke code ke execute hone ke baad
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const sliderElem = document.querySelector('.product-slideshow');
  if (!sliderElem) return;

  // Create wrapper div
  const wrapper = document.createElement("div");
  wrapper.className = "product-mobile-left-right-icon";

  // Create left & right icons
  const leftArrow = document.createElement("button");
  leftArrow.className = "custom-prod-arrow custom-prod-prev";
  leftArrow.innerHTML = "&#10094;";

  const rightArrow = document.createElement("button");
  rightArrow.className = "custom-prod-arrow custom-prod-next";
  rightArrow.innerHTML = "&#10095;";

  // Add icons to wrapper
  wrapper.appendChild(leftArrow);
  wrapper.appendChild(rightArrow);

  // Add wrapper after slider loads
  sliderElem.appendChild(wrapper);

  // Wait for Flickity instance
  let flickityInstance;
  let attempts = 0;

  const checkFlickity = setInterval(() => {
    attempts++;

    // Get active Flickity instance
    flickityInstance = Flickity.data(sliderElem);

    if (flickityInstance) {
      leftArrow.addEventListener("click", () => flickityInstance.previous());
      rightArrow.addEventListener("click", () => flickityInstance.next());
      clearInterval(checkFlickity);
    }

    if (attempts > 20) clearInterval(checkFlickity);
  }, 200);
});


// Product-page-zoom-js
document.addEventListener("DOMContentLoaded", function () {
  const zoomWindow = document.querySelector(".zoom-window");
  // zoom logic for any image
  function addZoomFunction(img) {
    img.addEventListener("mousemove", function (e) {
      zoomWindow.style.display = "block";
      zoomWindow.style.backgroundImage = `url(${img.src})`;
      let rect = img.getBoundingClientRect();
      let x = ((e.clientX - rect.left) / img.width) * 100;
      let y = ((e.clientY - rect.top) / img.height) * 100;
      zoomWindow.style.backgroundPosition = `${x}% ${y}%`;
    });
    img.addEventListener("mouseleave", function () {
      zoomWindow.style.display = "none";
    });
  }
  // apply zoom on all current images
  function initZoom() {
    const imgs = document.querySelectorAll(".product-image-main image-element img");
    imgs.forEach(img => addZoomFunction(img));
  }
  // Run initially
  initZoom();
  // Re-run zoom after ANY image change
  document.addEventListener("click", function () {
    setTimeout(initZoom, 250);
  });
});





